import { ReactElement } from 'react';

export enum NotificationVariants {
  error = 'error',
  success = 'success',
  info = 'info',
  neutral = 'neutral'
}

export interface INotificationProps {
  variant: NotificationVariants | keyof typeof NotificationVariants;
  message: string | JSX.Element;
  fullWidth?: boolean;
  className?: string;
  closeIcon?: boolean;
  additionalText?: string;
  button?: JSX.Element;
  onClose?: () => void;
  isSnackBar?: boolean;
  custom?: boolean;
  customTitle?: ReactElement | null;
  children?: ReactElement | ReactElement[] | null;
  icon?: ReactElement;
}
